import React, { Component } from 'react';
import PropTypes from 'prop-types';

import * as Theme from "../../../app/Theme";

import {RS} from "../../../data/strings/global";
import * as SC from "../../../data/strings/RCStringConst";

import TButton from "../../common/TButton";
import TCheckBox from "../../common/TCheckBox";
import TAccordion from "../../common/TAccordian";

import * as gbu from "../../GB/GBUtil";

import * as rcc from "../NonVisual/RCConst";
import {
    getAnyIndicatorSelected
} from "../NonVisual/RCDataUtil";
import RCNavBtnDiv from "../Other/RCNavBtnDiv";
import * as rcdu from "../NonVisual/RCDataUtil";

const divWidth = 400;

class RCSelectIndicatorsForm extends Component {

    static propTypes = {

        appBarHeight               : PropTypes.oneOf([PropTypes.number, PropTypes.string]),
        appSideBarWidth            : PropTypes.oneOf([PropTypes.number, PropTypes.string]),

        onGroupPanelExpandedChange : PropTypes.func,
        groupObjList               : PropTypes.arrayOf(PropTypes.object),

        indicatorObjList           : PropTypes.arrayOf(PropTypes.object),
        onAnalyzeIndicatorChange   : PropTypes.func,
        onIndicatorNameChange      : PropTypes.func,
        onIndicatorObjListChange   : PropTypes.func,

        onDrawerChange             : PropTypes.func,
        onPageChange               : PropTypes.func,

        selectedIndCurrID          : PropTypes.number,
        onSelectedIndicatorChange  : PropTypes.func,

    };

    static defaultProps = {

        appBarHeight             : 0,
        appSideBarWidth          : 0,

        groupObjList             : [],
        onGroupPanelExpandedChange : () => console.log("onGroupPanelExpandedChange"),

        indicatorObjList         : [],
        onAnalyzeIndicatorChange : () => console.log("onAnalyzeIndicatorChange"),
        onIndicatorNameChange    : () => console.log("onIndicatorNameChange"),
        onIndicatorObjListChange : () => console.log("onIndicatorObjListChange"),

        onDrawerChange           : () => console.log("onDrawerChange"),
        onPageChange             : () => console.log("onPageChange"),

        selectedIndCurrID           : 1,
        onSelectedIndicatorChange   : () => console.log("onSelectedIndicatorChange"),

    };

    onIndCheckBoxClick = (checked, event, name, caption, info) => {

        try {

            const props = this.props;
            const indicatorObjList = gbu.cloneObj(props.indicatorObjList);
            let selectedIndCurrID = props.selectedIndCurrID;

            selectedIndCurrID = rcdu.onAnalyzeIndicatorChange(info, checked, indicatorObjList, selectedIndCurrID);

            props.onIndicatorObjListChange(indicatorObjList, () => {

                props.onSelectedIndicatorChange(selectedIndCurrID);

            });

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onClearBtnClick = () => {

        try {

            const props = this.props;
            const indicatorObjList = gbu.cloneObj(props.indicatorObjList);
            let selectedIndCurrID = props.selectedIndCurrID;

            selectedIndCurrID = rcdu.onAnalyzeIndicatorChange(rcc.allIndicators, false, indicatorObjList, selectedIndCurrID);

            props.onIndicatorObjListChange(indicatorObjList, () => {

                props.onSelectedIndicatorChange(selectedIndCurrID);

            });

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onExpansionPanelClick = (expanded, event) => {

        try {

            this.props.onGroupPanelExpandedChange(event, expanded);

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onMngCustomIndBtnClick = () => {

        try {

            this.props.onDrawerChange(rcc.customIndDrawer);

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    renderIndicatorAccordion = () => {

        try {

            let accordion;

            const props = this.props;
            const indicatorObjList = props.indicatorObjList;
            const groupObjList = props.groupObjList;

            let accordionContentArray = [];
            let group1DStrArray = [];
            let expanded1DBoolArray = [];

            for (let g = 1; g <= groupObjList.length; g++) {

                const groupName = rcdu.getGroupName(g, groupObjList);
                const groupPanelExpandedBool = rcdu.getGroupPanelExpanded(g, groupObjList);

                group1DStrArray.push(groupName);

                let indCheckBox1DArray = [];

                for (let i = 1; i <= indicatorObjList.length; i++) {

                    const groupCurrID = rcdu.getIndGroupCurrID(i, indicatorObjList);
                    const analyzeBool = rcdu.getIndAnalyzeBool(i, indicatorObjList);

                    if (g === groupCurrID) {

                        const indName = rcdu.getIndName(i, indicatorObjList);

                        const indCheckBox =
                            <TCheckBox
                                caption = {indName}
                                onClick = {this.onIndCheckBoxClick}
                                custom  = {i}
                                style   = {{
                                    height : "auto",
                                    marginBottom : 10,
                                }}
                                value = {analyzeBool}
                            />;

                        indCheckBox1DArray.push(indCheckBox);
                        expanded1DBoolArray.push(groupPanelExpandedBool);

                    }

                }

                /* Create a group fragment */
                const groupDiv =
                    <div
                        key = {groupName + "Fragment"}
                        style = {{
                            color      : Theme.RC_SecondaryColor,
                            fontFamily : Theme.fontFamily,
                        }}
                    >
                        {indCheckBox1DArray}
                    </div>;

                accordionContentArray.push(groupDiv);

            }

            accordion =
                <div
                    style = {{
                        display    : "inline-block",
                        height     : 600,
                        marginLeft : 20,
                        marginTop  : 20,
                        overflowX  : "hidden",
                        overflowY  : "scroll",
                        position   : "relative",
                        top        : 10 + 80 + 10, //80 is approx height of label
                        width      : divWidth,
                    }}
                >
                    <TAccordion
                        content               = {accordionContentArray}
                        expanded              = {expanded1DBoolArray}
                        items                 = {group1DStrArray}
                        key                   = {"indicatorAccordion"}
                        summaryStyle          = {{
                            color      : Theme.RC_PrimaryColor,
                            fontFamily : Theme.fontFamily,
                            fontSize   : 20,
                        }}
                        // onExpansionPanelClick = {this.onExpansionPanelClick}
                    />
                </div>;

            return accordion;

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);
            return null;

        }

    };

    renderSelectedIndDiv = () => {

        try {

            let div;

            const props = this.props;
            const indicatorObjList = props.indicatorObjList;

            const yourIndLab =
                <p
                    style = {{
                        color      : Theme.RC_SecondaryColor,
                        fontFamily : Theme.fontFamily,
                        fontSize   : 20,
                        marginTop  : 0,
                    }}
                >
                    {RS(SC.GB_stYourIndicators)}
                </p>;

            let indLab1DArray = [];

            for (let i = 1; i <= indicatorObjList.length; i++) {

                const analyzeBool = rcdu.getIndAnalyzeBool(i, indicatorObjList);

                if (analyzeBool) {

                    const indName = rcdu.getIndName(i, indicatorObjList);

                    const indLab =
                        <p
                            style = {{
                                fontFamily : Theme.fontFamily,
                                fontSize   : 14,
                                margin     : 0,
                            }}
                        >
                            {indName}
                        </p>;

                    indLab1DArray.push(indLab);

                }

            }

            const clearBtn =
                <TButton
                    caption = {RS(SC.GB_stClear)}
                    onClick = {this.onClearBtnClick}
                    style   = {{
                        marginTop : 20,
                    }}
                />;

            div =
                <div
                    style = {{
                        backgroundColor : Theme.lightGrayColor,
                        display         : "inline-block",
                        marginLeft      : Theme.leftIndent,
                        marginTop       : 20,
                        width           : divWidth,
                        padding         : 20,
                    }}
                >
                    {yourIndLab}
                    {indLab1DArray}
                    {clearBtn}
                </div>;

            return div;

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);
            return null;

        }

    };

    render() {

        const props = this.props;
        const onPageChange = props.onPageChange;
        const indicatorObjList = props.indicatorObjList;
        const appSideBarWidth = props.appSideBarWidth;

        const instructionsLabel =
            <p
                style   = {{
                    ...Theme.labelStyle,
                    marginLeft    : Theme.leftIndent,
                    marginBottom  : 0,
                }}
            >
                {RS(SC.GB_stSelectIndInstruct)}
            </p>;

        const indicatorAccordion = this.renderIndicatorAccordion();
        const selectedIndDiv = this.renderSelectedIndDiv();

        const mngCustomIndBtn =
            <TButton
                caption = {RS(SC.GB_stMngCustomIndicators)}
                onClick = {this.onMngCustomIndBtnClick}
                style   = {{
                    marginTop  : 20,
                    marginLeft : Theme.leftIndent,
                }}
            />;

        const navBtnDiv =
            <RCNavBtnDiv
                divStyle       = {{
                    marginTop : 20,
                }}
                nextBtnEnabled = {getAnyIndicatorSelected(indicatorObjList)}
                onBackBtnClick = {() => onPageChange(rcc.welcomeForm)}
                onNextBtnClick = {() => onPageChange(rcc.assignTargPopsForm)}
            />;

        const indDiv =
            <div
                className = {"indDiv"}
                key       = {"indDiv"}
                style     = {{
                    alignItems     : "flex-start",
                    alignContent   : "flex-start",
                    display        : "flex",
                    flexDirection  : "row",
                    flexWrap       : "wrap",
                    justifyContent : "flex-start",
                    position       : "relative",
                }}
            >
                {indicatorAccordion}

                <div
                    className = {"indDiv"}
                    key       = {"indDiv"}
                    style     = {{
                        alignItems     : "flex-start",
                        alignContent   : "flex-start",
                        display        : "flex",
                        flexDirection  : "column",
                        justifyContent : "flex-start",
                        position       : "fixed",
                        left           : divWidth + Theme.leftIndent + appSideBarWidth,
                    }}
                >
                    {selectedIndDiv}
                    {mngCustomIndBtn}
                    {navBtnDiv}
                </div>

            </div>;

        return (

            <React.Fragment>
                <div
                    style = {{
                        position : "fixed",
                        width    : divWidth,
                    }}
                >
                    {instructionsLabel}
                </div>

                {indDiv}
            </React.Fragment>

        );

    }

}

export default RCSelectIndicatorsForm;
